module.exports = __webpack_public_path__ + "img/weixin-circle.9f400e81.png";